// TẠM ẨN (29/09/2026): ẩn toàn bộ Lưu trú trên giao diện — popup tự mở, thẻ trên trang chủ hạnh
// sinh và mục menu của ban quản lý. Mở lại: đổi thành false, không cần đụng gì khác.
// (Tách file riêng để menu không phải kéo theo cả module popup lưu trú.)
export const TAM_AN_LUU_TRU = true;
